import { supabase, imageUrl, parseImages, STORAGE_BASE } from './supabase';

/**
 * Capa de datos pública del sitio.
 *
 * Los datos vienen de Supabase (tablas `productos` y `proyectos`) y las
 * imágenes del bucket `catalogo`. Las firmas exportadas se mantienen
 * idénticas a las de la API anterior para no tocar los componentes que
 * las consumen.
 */

async function selectAll(table) {
  const { data, error } = await supabase.from(table).select('*');

  if (error) {
    throw new Error(`Supabase falló al leer «${table}»: ${error.message}`);
  }

  return Array.isArray(data) ? data : [];
}

export const getProducts = () => selectAll('productos');

export const getProjects = () => selectAll('proyectos');

export { imageUrl, parseImages, STORAGE_BASE };
